import React from "react";
import {
  FiFolder,
  FiLayers,
  FiCheckSquare,
  FiClipboard,
  FiAlertCircle,
  FiClock,
} from "react-icons/fi";
import "./DashCards.scss";

export default function DashCards({ counts = null }) {
  const fallback = {
    projects: { total: 0, completed: 0, active: 0 },
    tasks: { total: 0, completed: 0, overdue: 0, dueToday: 0 },
    todos: { total: 0, completed: 0, overdue: 0 },
    todolists: { total: 0, active: 0 },
  };

  const c = counts ?? fallback;

  const cards = [
    {
      id: "projects",
      title: "Projects",
      color: "#6c63ff",
      bg: "#ededfd",
      total: Number(c.projects?.total ?? 0),
      primaryLabel: "Completed",
      primaryValue: Number(c.projects?.completed ?? 0),
      secondaryLabel: "Active",
      secondaryValue: Number(c.projects?.active ?? 0),
      secondaryIcon: <FiLayers size={12} />,
      icon: <FiFolder size={20} />,
    },
    {
      id: "stages",
      title: "Stages",
      color: "#fb8c00",
      bg: "#fff3e0",
      total: Number(c.tasks?.total ?? 0),
      primaryLabel: "Completed",
      primaryValue: Number(c.tasks?.completed ?? 0),
      secondaryLabel: "Overdue",
      secondaryValue: Number(c.tasks?.overdue ?? 0),
      secondaryIcon: <FiAlertCircle size={12} />,
      icon: <FiCheckSquare size={20} />,
    },
    {
      id: "tasks",
      title: "Tasks",
      color: "#4aa0f0",
      bg: "#e3f2fd",
      total: Number(c.todos?.total ?? 0),
      primaryLabel: "Completed",
      primaryValue: Number(c.todos?.completed ?? 0),
      secondaryLabel: "Overdue",
      secondaryValue: Number(c.todos?.overdue ?? 0),
      secondaryIcon: <FiAlertCircle size={12} />,
      icon: <FiClipboard size={20} />,
    },
    {
      id: "todolists",
      title: "Todo Lists",
      color: "#8e44ad",
      bg: "#f3e5f5",
      total: Number(c.todolists?.total ?? 0),
      primaryLabel: "Active",
      primaryValue: Number(c.todolists?.active ?? 0),
      secondaryLabel: "Total",
      secondaryValue: Number(c.todolists?.total ?? 0),
      secondaryIcon: <FiClock size={12} />,
      icon: <FiFolder size={20} />,
    },
  ];

  return (
    <div className="dc-grid">
      {cards.map((card) => {
        const {
          id,
          title,
          color,
          bg,
          icon,
          total,
          primaryLabel,
          primaryValue,
          secondaryLabel,
          secondaryValue,
        } = card;
        const pct = total > 0 ? Math.round((primaryValue / total) * 100) : 0;
        const isAlert = secondaryLabel === "Overdue" && secondaryValue > 0;

        return (
          <div key={id} className="dc-card">
            {/* Icon + title */}
            <div className="dc-top">
              <div className="dc-icon-wrap" style={{ background: bg, color }}>
                {icon}
              </div>
              <div className="dc-title-wrap">
                <h4 className="dc-title">{title}</h4>
                <span className="dc-total">
                  {total} <span className="dc-total-label">total</span>
                </span>
              </div>
              {/* Percent badge top-right */}
              <div className="dc-pct-badge" style={{ color, background: bg }}>
                {pct}%
              </div>
            </div>

            {/* Progress bar */}
            <div
              className="dc-progress-track"
              title={`${pct}% ${primaryLabel}`}
            >
              <div
                className="dc-progress-fill"
                style={{ width: `${pct}%`, background: color }}
              />
            </div>

            {/* Primary + secondary */}
            <div className="dc-stats">
              <div className="dc-stat">
                <span className="dc-stat-value">{primaryValue}</span>
                <span className="dc-stat-label">{primaryLabel}</span>
              </div>
              <div className="dc-divider" />
              <div className={`dc-stat ${isAlert ? "dc-stat--alert" : ""}`}>
                <span
                  className="dc-stat-value"
                  style={isAlert ? { color: "#ef4444" } : {}}
                >
                  {secondaryValue}
                </span>
                <span className="dc-stat-label dc-stat-label--icon">
                  {isAlert && <span className="dc-alert-dot" />}
                  {secondaryLabel}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
